import { render, staticRenderFns } from "./select-fleet.vue?vue&type=template&id=175c0cd8&scoped=true&"
import script from "./select-fleet.vue?vue&type=script&lang=js&"
export * from "./select-fleet.vue?vue&type=script&lang=js&"
import style0 from "./select-fleet.vue?vue&type=style&index=0&id=175c0cd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175c0cd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
